import React,{useState,useEffect,useRef} from 'react'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Button} from 'react-bootstrap'
import {AiOutlinePlus} from 'react-icons/ai'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import ReactPaginate from 'react-paginate';
import moment from 'moment'
import {BsSearch} from 'react-icons/bs'
import { empwiseattApi } from '../../../utils/AdminDashApi/EmpWiseAttApi'
import '../../../sassFiles/sassPages/admindashboard/campwiseatten.scss'
import '../../../sassFiles/sassPages/admindashboard/adminCommon.scss'
import { campwiseattApi } from '../../../utils/AdminDashApi/CampWiseAttApi'
import { empAttreportApi } from '../../../utils/AdminDashApi/EmpAttReportApi'
import { BsPlus } from 'react-icons/bs'
import { optionsStatus, optionsdayofmonth, optionsdayofweek, optionsdept, optionsdesignation } from '../../Helper'
import { validationComp, validationDrp } from '../../subComponents/CustomSubComponents/ValidationComp'
import { attendancePolicyApi } from '../../../utils/AdminDashApi/AttendancePolicyApi'
const AttendancePolicyComp = () => {
  const [activefrom,setactivefrom] = useState("")
  const [activeto,setactiveTo] = useState("")
  
  const [activefrommdlnm,setactivefrommdlnm] = useState("")
  const [activetomdl,setactiveTomdl] = useState("")
  const [activetomdlnm,setactiveTomdlnm] = useState("")
  const [show,setShow] = useState(10)
  const [show2,setShow2] = useState("")
  const [department,setdepartment] = useState("")
  const [labeldepartment,setlabeldepartment] = useState("")
  const [borderdepartment,setborderdepartment] = useState("")
  const [campus,setcampus]= useState("")
  const [bordercampus,setbordercampus]= useState("")
  const [labelcampus,setlabelcampus]= useState("")
  const [type,settype]= useState("")
  const [bordertype,setbordertype]= useState("")
  const [labeltype,setlabeltype]= useState("")
  const [searchkey,setsearchkey]=useState("")

  const handleShowEdit=(e,item)=>{
    setShow3(true)
  }

  

  const handleInputSearch=(e)=>{
    setsearchkey(e.target.value)
  }

  const handleSearchButton=()=>{

  }
  
 
  const [roleDrp,setRoledrp] = useState("")
  const handleShow = () => setShow2(true);
 
  const optionsShowt = [
    {
      id:0,
      opt:"Select"
    }
    ,{
      id:1,
      opt:10
    },
    {
      id:2,
      opt:20
    },
    {
      id:3,
      opt:30
    },
  ]
  const [mainpagesearch,setmainpagesearch] = useState("")
  const handlemainpagesearch=(e)=>{
    setmainpagesearch(e.target.value)
  }
  const [statusvalueerr,setstatusvalueerr] = useState("")
  const [activefromMoment,setactivefromMoment] = useState("")


  
  
      const handleActiveTo = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setactiveTomdl(dtfinalc)

            
        }
        
        
    }
   
 

    const [show3, setShow3] = useState(false);
    const [modalitem,setmodalitem] = useState({})
    
  const [currentItems, setCurrentItems] = useState([]);
  const [currentItemsmodel, setCurrentItemsmodel] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [pageCountfiltered, setPageCountfiltered] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);
  const [itemOffsetfiltered, setItemOffsetfiltered] = useState(0);
  const [itemsPerPage,setitemsPerPage] = useState(10);
  const [paginatenumselected,setpaginatenumselected] = useState(0)
  const [paginatenumselectedfiltered,setpaginatenumselectedfiltered] = useState(0)
  const [pageCount2, setPageCount2] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset2, setItemOffset2] = useState(0);
  const [itemsPerPage2,setitemsPerPage2] = useState(10);
  
  const [itemsPerPagefiltered,setitemsPerPagefiltered] = useState(10);
  const [paginatenumselected2,setpaginatenumselected2] = useState(0)
  const [filteredArr,setfilteredArr] = useState(attendancePolicyApi.data)



  const mainfilter=(arr)=>{
      setfilteredArr(arr);    
  }

  const drpfunctiondepartment=(myval,myid)=>{
    setdepartment(myval)
  }
  const drpfunctioncampus=(myval,myid)=>{
    setcampus(myval)
  }
  const drpfunctiontype=(myval,myid)=>{
    settype(myval)
  }



  const [tempfilteredarr,settempfilteredarr] = useState([])

  let [pagecountoffilter,setpagecountoffilter] = useState(filteredArr.length)
  

  useEffect(() => {
    const endOffsetfiltered = itemOffsetfiltered + itemsPerPagefiltered;
    const tempArr = filteredArr.slice(itemOffsetfiltered, endOffsetfiltered);
    settempfilteredarr(tempArr);
    setPageCountfiltered(Math.ceil(filteredArr.length / itemsPerPagefiltered));
    setitemsPerPagefiltered(show?show:10)
    //flag2
  }, [itemOffsetfiltered, itemsPerPagefiltered, filteredArr,show]);

      const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % attendancePolicyApi.data.length;        
        setpaginatenumselected(event.selected);
        setItemOffset(newOffset);
      };
      const handlePageClickfiltered = (event) => {
        const newOffsetf = event.selected * itemsPerPagefiltered % pagecountoffilter;        
        setpaginatenumselectedfiltered(event.selected);
        setItemOffsetfiltered(newOffsetf);
      };
    
      
    const [idsave,setidsave]=useState(false)
    
    const [searchinputmodal,setsearchinputmodal] = useState("")
    const [rolesearchkey,setrolesearchkey] = useState("")
    const handlesearchinputmodal=(e)=>{
      setsearchinputmodal(e.target.value)      
    }
    const handlesearchmodal=()=>{
      setrolesearchkey(searchinputmodal)
    }
    const drpfuncshow=(myshow,id)=>{
      setShow(myshow)
      
    }
    
    const [ischkmodal,setischkmodal] = useState(false)
    const handleChangechk = event => {
      if (event.target.checked) {
        console.log('✅ Checkbox is checked');
      } else {
        console.log('⛔️ Checkbox is NOT checked');
      }
      setischkmodal(current => !current);
    };
   

   
    const [formdata,setfromdata]=useState({
      usersearch:""
    })
    

    // populatedata
    const [name,setname] = useState("")
    const [id,setid] = useState("")

    const handleSearchclick =()=>{
       
        const foundItem = attendancePolicyApi.data.find(item => item.id.toString() == formdata.usersearch);

        if (foundItem) {
          setidsave(true);
          setname(foundItem.name);
          setid(foundItem.id)
          console.log(foundItem.name);
        } else {
          setidsave(false);
        }
            
        
          mainfilter(attendancePolicyApi.data) 
      
    }
   

   
    
    
    const optionsparentmenu = [
      {
        id:1,
        opt:"Home1"
      },
      {
        id:2,
        opt:"Home2"
      },
    ]
    const [parentmenudrp,setparentmenudrp] = useState("")
    const drpfuncparentmenu=(parentmenydrpval,myid)=>{
      setparentmenudrp(parentmenydrpval)
    }
    const [menumodalimg,setmenumodalimg] = useState("")
  

    const [dayofweekmod1,setdayofweekmod1] = useState("")
    const [labeldayofweekmod1,setlabeldayofweekmod1] = useState("")
    const [borderdayofweekmod1,setborderdayofweekmod1] = useState("")
    
    const [startdatemod1,setstartdatemod1] = useState("")
    const [labelstartdatemod1,setlabelstartdatemod1] = useState("")
    const [borderstartdatemod1,setborderstartdatemod1] = useState("")
  
    const [enddatemod1,setenddatemod1] = useState("")
    const [labelenddatemod1,setlabelenddatemod1] = useState("")
    const [borderenddatemod1,setborderenddatemod1] = useState("")
  
  const [startdatemod2,setstartdatemod2] = useState("")
  const [labelstartdatemod2,setlabelstartdatemod2] = useState("")
  const [borderstartdatemod2,setborderstartdatemod2] = useState("")

  const [enddatemod2,setenddatemod2] = useState("")
  const [labelenddatemod2,setlabelenddatemod2] = useState("")
  const [borderenddatemod2,setborderenddatemod2] = useState("")

  const [departmentmain,setdepartmentmain] = useState("")
  const [borderdepartmentmain,setborderdepartmentmain] = useState("")
  const [labeldepartmentmain,setlabeldepartmentmain] = useState("")

  const [designationmain,setdesignationmain] = useState("")
  const [borderdesignationmain,setborderdesignationmain] = useState("")
  const [labeldesignationmain,setlabeldesignationmain] = useState("")
  
  const [activefrommain,setactivefrommain] = useState("")
  const [borderactivefrommain,setborderactivefrommain] = useState("")
  const [labelactivefrommain,setlabelactivefrommain] = useState("")
    
  const [activetomain,setactivetomain] = useState("")
  const [borderactivetomain,setborderactivetomain] = useState("")
  const [labelactivetomain,setlabelactivetomain] = useState("")
    
  const [departmentmod1,setdepartmentmod1] = useState("")
  const [borderdepartmentmod1,setborderdepartmentmod1] = useState("")
  const [labeldepartmentmod1,setlabeldepartmentmod1] = useState("")

  const [designationmod1,setdesignationmod1] = useState("")
  const [borderdesignationmod1,setborderdesignationmod1] = useState("")
  const [labeldesignationmod1,setlabeldesignationmod1] = useState("")

  const [maximumlatemod1,setmaximumlatemod1] = useState("")
  const [bordermaximumlatemod1,setbordermaximumlatemod1] = useState("")
  const [labelmaximumlatemod1,setlabelmaximumlatemod1] = useState("") 

  const [maximumearlyleavemod1,setmaximumearlyleavemod1] = useState("")
  const [bordermaximumearlyleavemod1,setbordermaximumearlyleavemod1] = useState("")
  const [labelmaximumearlyleavemod1,setlabelmaximumearlyleavemod1] = useState("")

  const [rainydayallowancemod1,setrainydayallowancemod1] = useState("")
  const [borderrainydayallowancemod1,setborderrainydayallowancemod1] = useState("")
  const [labelrainydayallowancemod1,setlabelrainydayallowancemod1] = useState("")

  const [activefrommod1,setactivefrommod1] = useState("")
  const [borderactivefrommod1,setborderactivefrommod1] = useState("")
  const [labelactivefrommod1,setlabelactivefrommod1] = useState("")

  const [activetomod1,setactivetomod1] = useState("")
  const [borderactivetomod1,setborderactivetomod1] = useState("")
  const [labelactivetomod1,setlabelactivetomod1] = useState("")

  const [statusmod1,setstatusmod1] = useState("")
  const [borderstatusmod1,setborderstatusmod1] = useState("")
  const [labelstatusmod1,setlabelstatusmod1] = useState("")

  const [departmentmod2,setdepartmentmod2] = useState("")
  const [borderdepartmentmod2,setborderdepartmentmod2] = useState("")
  const [labeldepartmentmod2,setlabeldepartmentmod2] = useState("")

  const [designationmod2,setdesignationmod2] = useState("")
  const [borderdesignationmod2,setborderdesignationmod2] = useState("")
  const [labeldesignationmod2,setlabeldesignationmod2] = useState("")

  const [maximumlatemod2,setmaximumlatemod2] = useState("")
  const [bordermaximumlatemod2,setbordermaximumlatemod2] = useState("")
  const [labelmaximumlatemod2,setlabelmaximumlatemod2] = useState("") 

  const [maximumearlyleavemod2,setmaximumearlyleavemod2] = useState("")
  const [bordermaximumearlyleavemod2,setbordermaximumearlyleavemod2] = useState("")
  const [labelmaximumearlyleavemod2,setlabelmaximumearlyleavemod2] = useState("")

  const [rainydayallowancemod2,setrainydayallowancemod2] = useState("")
  const [borderrainydayallowancemod2,setborderrainydayallowancemod2] = useState("")
  const [labelrainydayallowancemod2,setlabelrainydayallowancemod2] = useState("")

  const [activefrommod2,setactivefrommod2] = useState("")
  const [borderactivefrommod2,setborderactivefrommod2] = useState("")
  const [labelactivefrommod2,setlabelactivefrommod2] = useState("")

  const [activetomod2,setactivetomod2] = useState("")
  const [borderactivetomod2,setborderactivetomod2] = useState("")
  const [labelactivetomod2,setlabelactivetomod2] = useState("")

  const [statusmod2,setstatusmod2] = useState("")
  const [borderstatusmod2,setborderstatusmod2] = useState("")
  const [labelstatusmod2,setlabelstatusmod2] = useState("")

    const drpfuncdesignationmain=(myval,myid)=>{
        setdesignationmain(myval)
    }
   
    const drpfuncstatusmod1=(myval,myid)=>{
      setstatusmod1(myval)
    }
    const drpfuncstatusmod2=(myval,myid)=>{
      setstatusmod2(myval)
    }
    
   
    const drpfunctiondepartmentmain=(myval,myid)=>{
      setdepartmentmain(myval)
    }
    const drpfunctiondepartmentmod1=(myval,myid)=>{
      setdepartmentmod1(myval)
    }
    const drpfunctiondepartmentmod2=(myval,myid)=>{
      setdepartmentmod2(myval)
    }
    const drpfuncdesignationmod1=(myval,myid)=>{
      setdesignationmod1(myval)
    }
    const drpfuncdesignationmod2=(myval,myid)=>{
      setdesignationmod2(myval)
    }

    const handleactivefrommain = (activefromval)=>{

      if(activefromval != null){
        
          var dtmnt = activefromval.$M + 1;
          var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
         
          setactivefrommain(moment(dtfinalc).format("YYYY-MM-DD"))
      }  
  }
    const handleactivetomain = (activefromval)=>{

      if(activefromval != null){
        
          var dtmnt = activefromval.$M + 1;
          var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
         
          setactivetomain(moment(dtfinalc).format("YYYY-MM-DD"))
      }  
  }
    const handleactivefrommod1 = (activefromval)=>{

      if(activefromval != null){
        
          var dtmnt = activefromval.$M + 1;
          var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
         
          setactivefrommod1(moment(dtfinalc).format("YYYY-MM-DD"))
      }  
  }
    const handleactivefrommod2 = (activefromval)=>{

      if(activefromval != null){
        
          var dtmnt = activefromval.$M + 1;
          var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
         
          setactivefrommod2(moment(dtfinalc).format("YYYY-MM-DD"))
      }  
  }
    const handleactivetomod1 = (activefromval)=>{

      if(activefromval != null){
        
          var dtmnt = activefromval.$M + 1;
          var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
         
          setactivetomod1(moment(dtfinalc).format("YYYY-MM-DD"))
      }
      
    }
    const handleactivetomod2 = (activefromval)=>{

      if(activefromval != null){
        
          var dtmnt = activefromval.$M + 1;
          var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
         
          setactivetomod2(moment(dtfinalc).format("YYYY-MM-DD"))
      }
      
    }
   
  
  
  const handleInput = (e)=>{
    setfromdata({...formdata,[e.target.name]:e.target.value})
  }

  const handleCloseMod1=()=>{
    setShow2(false)
  }
  const handlesaveModal1=()=>{

    validationDrp(departmentmod1,setlabeldepartmentmod1,setborderdepartmentmod1,"Department Required")
    validationDrp(designationmod1,setlabeldesignationmod1,setborderdesignationmod1,"Designation Required")
    validationComp(maximumlatemod1,setlabelmaximumlatemod1,setbordermaximumlatemod1,"Max Late Required")
    validationComp(maximumearlyleavemod1,setlabelmaximumearlyleavemod1,setbordermaximumearlyleavemod1,"Max Early Leave Required")
    validationComp(rainydayallowancemod1,setlabelrainydayallowancemod1,setborderrainydayallowancemod1,"Rainy Day Allowance Required")
    validationDrp(statusmod1,setlabelstatusmod1,setborderstatusmod1,"Status Required")
    validationDrp(activefrommod1,setlabelactivefrommod1,setborderactivefrommod1,"Active From Required")
    validationDrp(activetomod1,setlabelactivetomod1,setborderactivetomod1,"Active To Required")


  }

  const handlesaveModal2=()=>{

    validationDrp(departmentmod2,setlabeldepartmentmod2,setborderdepartmentmod2,"Department Required")
    validationDrp(designationmod2,setlabeldesignationmod2,setborderdesignationmod2,"Designation Required")
    validationComp(maximumlatemod2,setlabelmaximumlatemod2,setbordermaximumlatemod2,"Max Late Required")
    validationComp(maximumearlyleavemod2,setlabelmaximumearlyleavemod2,setbordermaximumearlyleavemod2,"Max Early Leave Required")
    validationComp(rainydayallowancemod2,setlabelrainydayallowancemod2,setborderrainydayallowancemod2,"Rainy Day Allowance Required")
    validationDrp(statusmod2,setlabelstatusmod2,setborderstatusmod2,"Status Required")
    validationDrp(activefrommod2,setlabelactivefrommod2,setborderactivefrommod2,"Active From Required")
    validationDrp(activetomod2,setlabelactivetomod2,setborderactivetomod2,"Active To Required")


  }

  const handleCloseMod2=()=>{
    setShow3(false)
  }


  //start
    
  return (
    <div className="d-flex flexvaluecomp htshiftsetup">

       <SidebarOfAdash/>
       <div className="contentpartwidthwrapper">
          <HeaderofAdash head="Attendance Policy"/>
          <div className="contentofadmindash contentflexvalue">
                <Row>
                    <Col lg={10} className="m-auto">
                <Row >
                <Col className="m-auto pr7">
                  <div className="basicinput">
                    <p></p>
                    <button className='cmbutton' onClick={handleShow}><BsPlus/>Add Policy</button>
                  </div>
                </Col> 
                <Col className='pr7 pl7'>
                <div className="basicinputfield h40p">
                <p>Department</p>
                <div className="inputgap h40">
                    <div className="dropdownwrapper">
                        <Dropdown2 err={borderdepartmentmain} func={drpfunctiondepartmentmain} myplaceholder={departmentmain }fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsdept} />
                    </div>
                    <label>{labeldepartmentmain}</label>
                    </div>
                </div>
                </Col>
                <Col className='pr7 pl7'>
                <div className="basicinputfield h40p">

                <p>Designaiton</p>
                <div className="inputgap h40">
                    <div className="dropdownwrapper">
                        <Dropdown2 err={borderdesignationmain} func={drpfuncdesignationmain} myplaceholder={designationmain}fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsdesignation} />
                    </div>
                    <label>{labeldesignationmain}</label>
                    </div>
                </div>
                </Col>

                    <Col className='pr7 pl7'>
                    <div className="basicinput h40p">
                        <p>Active From</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activefrommain}
                              onChange={(newvaldob)=>handleactivefrommain(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivefrommain == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active From"
                                }} error={false} />}
                          />
                          <label>{labelactivefrommain}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                    </Col>
                    <Col className=' pl7'>
                    <div className="basicinput h40p">
                        <p>Active To</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activetomain}
                              onChange={(newvaldob)=>handleactivetomain(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivetomain == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active From"
                                }} error={false} />}
                          />
                          <label>{labelactivetomain}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                    </Col>
                </Row>
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    <Col lg={4}>
                        <Row className="justify-content-center">
                            <Col lg={4} >
                            <div className="basicinput">
                            <p>Show</p>
                            <div className="dropdownwrapper">
                                
                                <Dropdown2 func={drpfuncshow} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsShowt}/>
                            </div>
                            </div>
                            </Col>
                            <Col lg={8}>
                              <div className="basicinput ">
                                <p>Search</p>
                                <div className="searchpositiondiv">

                              <input type="text" value={searchkey} onChange={handleInputSearch} name="searchword" placeholder='Search...'/>
                              <span onClick={handleSearchButton}>
                                  <img src="./assets/images/dashboards/adminDashboard/icon/searchicon.png" alt="" />
                              </span>
                                </div>
                              </div>
                            </Col>
                            
                        </Row>
                    </Col>
                </Row>
               

              <Row>
                <Col lg={10} className="m-auto">
                  <div className="flexvaluetable hrshiftsetuptablediv">
                    <table>
                      <thead>
                        <tr>
                            {
                              attendancePolicyApi.heading.map((item,key)=>{
                                return(
                                  <th style={item.head.length>=11?{fontSize:"13px"}:{}} key={key}> <div>{item.head}</div> </th>
                                )
                              })
                            }
                        </tr>
                      </thead>
                      {
                        // mainpagesearch==""?
                          <tbody>
                          {
                            tempfilteredarr.length!==0?
                          

                            tempfilteredarr.map((item,key)=>{
                              return(
                                <tr key={key}>
                                  <td>{item.id}</td>
                                  <td>{item.department}</td>
                                  <td>{item.designation}</td>
                                  <td>{item.maxlate}</td>
                                  <td>{item.maxearlyleave}</td>
                                  <td>{item.rainydayallow}</td>
                                  <td>{item.status}</td>
                                  <td>{item.activefrom}</td>
                                  <td>{item.activeto}</td>
                                  <td>
                                    <div className="img text-center">
                                      <img onClick={(e)=> handleShowEdit(e,item)} src={item.action} alt="" />  
                                    </div>  
                                  </td>
                                </tr>
                              )
                            })
                            :
                            ""
                            //  currentItems.map((item,key)=>{
                            //   return(
                            //     <tr key={key}>
                            //       <td>{item.punchdate}</td>
                            //       <td>{item.shifttime}</td>
                            //       <td>{item.intime}</td>
                            //       <td>{item.outtime}</td>
                            //       <td>{item.timelate}</td>
                            //       <td>{item.type}</td>
                            //     </tr>
                            //   )
                            // })
                         
                          }
                        </tbody>                        
                      }
                       
                    </table>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={10} className="m-auto">
                    {
                      filteredArr.length!==0?
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft'>Showing {itemOffsetfiltered+1} to {itemOffsetfiltered+10} of {filteredArr.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClickfiltered}
                      pageRangeDisplayed={5}
                      pageCount={pageCountfiltered}
                      previousLabel="previous"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                  </Col>
                  </Row>
                      
                      :
                      
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft'>Showing {itemOffset+1} to {itemOffset+10} of {campwiseattApi.data.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={5}
                      pageCount={pageCount}
                      previousLabel="previous"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                  </Col>
                  </Row>
                    }
                </Col>
               
              </Row>
              

               {/* modal1ori */}

              <Modal dialogClassName="mymodalclsSubjectAdmin" show={show2} onHide={handleCloseMod1} backdrop="static"
              keyboard={false}>
               
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Attendance Policy</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  
                  <Row>
                  <Col lg={6} className='pr7'>
                    <div className="basicinputfield h40p">
                    <p>Department</p>
                    <div className="inputgap h40">
                        <div className="dropdownwrapper">
                            <Dropdown2 err={borderdepartmentmod1} func={drpfunctiondepartmentmod1} myplaceholder={departmentmod1 }fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsdept} />
                        </div>
                        <label>{labeldepartmentmod1}</label>
                        </div>
                    </div>
                    </Col>
                    <Col lg={6} className="pl7">
                    <div className="basicinputfield h40p ">

                    <p>Designaiton</p>
                    <div className="inputgap h40">
                        <div className="dropdownwrapper">
                            <Dropdown2 err={borderdesignationmod1} func={drpfuncdesignationmod1} myplaceholder={designationmod1}fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsdesignation} />
                        </div>
                        <label>{labeldesignationmod1}</label>
                        </div>
                    </div>
                    </Col>
                    <Col lg={6} className="pr7">
                    <div className="basicinputfield h40p">
                            <p>Maximum Late</p>
                            <div className="inputgap h40">
                            <input style={bordermaximumlatemod1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={maximumlatemod1} onChange={(e) => setmaximumlatemod1(e.target.value)} />
                            <label>{labelmaximumlatemod1}</label>
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} className="pl7">
                    <div className="basicinputfield h40p">
                            <p>Maximum Early Leave</p>
                            <div className="inputgap h40">
                            <input style={bordermaximumearlyleavemod1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={maximumearlyleavemod1} onChange={(e) => setmaximumearlyleavemod1(e.target.value)} />
                            <label>{labelmaximumearlyleavemod1}</label>
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} className="pr7">
                    <div className="basicinputfield h40p">
                            <p>Rainy Day Time Allowance</p>
                            <div className="inputgap h40">
                            <input style={borderrainydayallowancemod1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={rainydayallowancemod1} onChange={(e) => setrainydayallowancemod1(e.target.value)} />
                            <label>{labelrainydayallowancemod1}</label>
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} className="pl7">
                    <div className="basicinputfield h40p ">

                    <p>Status</p>
                    <div className="inputgap h40">
                        <div className="dropdownwrapper">
                            <Dropdown2 err={borderstatusmod1} func={drpfuncstatusmod1} myplaceholder={statusmod1}fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsStatus} />
                        </div>
                        <label>{labelstatusmod1}</label>
                        </div>
                    </div>
                    </Col>
                    
                   
                        <Col lg={6} className=" pr7">
                        <div className="basicinput h40p">
                        <p>Active From</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activefrommod1}
                              onChange={(newvaldob)=>handleactivefrommod1(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivefrommod1 == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active From"
                                }} error={false} />}
                          />
                          <label>{labelactivefrommod1}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                        </Col>
                        <Col lg={6} className="pl7">
                        <div className="basicinput h40p">
                        <p>Active To</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activetomod1}
                              onChange={(newvaldob)=>handleactivetomod1(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivetomod1 == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active To"
                                }} error={false} />}
                          />
                          <label>{labelactivetomod1}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                        </Col>
                    
                  </Row>

                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" type="button" onClick={handleCloseMod1}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesaveModal1}>
                    Save
                  </button>
                </Modal.Footer>

                
              </Modal>
               {/* modal2ori */}

              <Modal dialogClassName="mymodalclsSubjectAdmin" show={show3} onHide={handleCloseMod2} backdrop="static"
              keyboard={false}>
               
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Attendance Policy</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  
                  
                <Row>
                  <Col lg={6} className='pr7'>
                    <div className="basicinputfield h40p">
                    <p>Department</p>
                    <div className="inputgap h40">
                        <div className="dropdownwrapper">
                            <Dropdown2 err={borderdepartmentmod2} func={drpfunctiondepartmentmod2} myplaceholder={departmentmod2 }fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsdept} />
                        </div>
                        <label>{labeldepartmentmod2}</label>
                        </div>
                    </div>
                    </Col>
                    <Col lg={6} className="pl7">
                    <div className="basicinputfield h40p ">

                    <p>Designaiton</p>
                    <div className="inputgap h40">
                        <div className="dropdownwrapper">
                            <Dropdown2 err={borderdesignationmod2} func={drpfuncdesignationmod2} myplaceholder={designationmod2}fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsdesignation} />
                        </div>
                        <label>{labeldesignationmod2}</label>
                        </div>
                    </div>
                    </Col>
                    <Col lg={6} className="pr7">
                    <div className="basicinputfield h40p">
                            <p>Maximum Late</p>
                            <div className="inputgap h40">
                            <input style={bordermaximumlatemod2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={maximumlatemod2} onChange={(e) => setmaximumlatemod2(e.target.value)} />
                            <label>{labelmaximumlatemod2}</label>
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} className="pl7">
                    <div className="basicinputfield h40p">
                            <p>Maximum Early Leave</p>
                            <div className="inputgap h40">
                            <input style={bordermaximumearlyleavemod2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={maximumearlyleavemod2} onChange={(e) => setmaximumearlyleavemod2(e.target.value)} />
                            <label>{labelmaximumearlyleavemod2}</label>
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} className="pr7">
                    <div className="basicinputfield h40p">
                            <p>Rainy Day Time Allowance</p>
                            <div className="inputgap h40">
                            <input style={borderrainydayallowancemod2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={rainydayallowancemod2} onChange={(e) => setrainydayallowancemod2(e.target.value)} />
                            <label>{labelrainydayallowancemod2}</label>
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} className="pl7">
                    <div className="basicinputfield h40p ">

                    <p>Status</p>
                    <div className="inputgap h40">
                        <div className="dropdownwrapper">
                            <Dropdown2 err={borderstatusmod2} func={drpfuncstatusmod2} myplaceholder={statusmod2}fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsStatus} />
                        </div>
                        <label>{labelstatusmod2}</label>
                        </div>
                    </div>
                    </Col>
                    
                   
                        <Col lg={6} className=" pr7">
                        <div className="basicinput h40p">
                        <p>Active From</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activefrommod2}
                              onChange={(newvaldob)=>handleactivefrommod2(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivefrommod2 == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active From"
                                }} error={false} />}
                          />
                          <label>{labelactivefrommod2}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                        </Col>
                        <Col lg={6} className="pl7">
                        <div className="basicinput h40p">
                        <p>Active To</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activetomain}
                              onChange={(newvaldob)=>handleactivetomod2(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivetomod2 == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active To"
                                }} error={false} />}
                          />
                          <label>{labelactivetomod2}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                        </Col>
                    
                  </Row>
                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" type="button" onClick={handleCloseMod2}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesaveModal2}>
                    Save
                  </button>
                </Modal.Footer>

                
              </Modal>
              
              </div>
              </div>
              </div>
  )
}

export default AttendancePolicyComp